export enum DiscountType {
    RELATIVE = 'relative',
}